module.exports = __webpack_public_path__ + "static/media/주식.b72be32c.png";